@if(filtersEnabled && filterOptions.length > 0) {
<finxone-web-frontend-finx-tags-container
  [filterOptions]="filterOptions"
  [filtersEnabled]="filtersEnabled"
  [filterMarginStyle]="filterMarginStyle"
  (filterChange)="onFilterChange($event)"
  [attri]="attri"
  [hideFilterCloseIcon]="true"
></finxone-web-frontend-finx-tags-container>
}
<div
  class="scrollable z-index-3 position-relative pointer-events-none"
  id="notification-list"
  [ngStyle]="pageConfig?.isUsingHtmlStructure ? { maxHeight: containerHeight } : {}"
  (scroll)="onScroll($event)"
>
  @if (listingNotifications.length > 0) { @for (notification of listingNotifications; track
  notification.notificationId) {
  <finxone-web-frontend-list-item
    [customHandlebarModel]="
      buildNotificationModel(
        notification.content,
        notification.title || '',
        notification.content,
        notification.createdAt,
        $index,
        notification.read
      )
    "
    [content]="content"
    (itemClicked)="onNotificationClick(notification)"
    [customClass]="'pointer-events-none' + (isGlobalStylingEnabled ? ' global-list-styling' : '')"
    [textContentStyle]="hasCustomStyles ? {} : getWidgetStyles(notification)"
    [gestures]="attri?.widgetProperties?.gestures"
    [listActions]="attri?.['listActions']"
    (actionTriggered)="onActionTriggered($event, notification)"
  ></finxone-web-frontend-list-item>
  } } @else if (listingNotificationLoading) {
  <div class="w-100" [innerHTML]="renderFetchingTemplateFunction() | safeHtml"></div>
  } @else {
  <div [innerHTML]="renderNoRecordsTemplate() | safeHtml"></div>
  }
</div>
